export const PEG_ADMIN_MARKER_COOKIE = 'peg_admin_marker'
export const PEG_RETAILER_AUTH_COOKIE = 'peg_retailer_auth'
